import merge from 'lodash-es/merge';

export class OperationComponentsLoader {
    static get operations() {
        return {
            'SELFID_NFC_START': {},
            'CERTIFICATE_SELFID_NFC_START': {
                success: 'operations/digital-sign/VerificationCompleted',
                error: {
                    '400': 'operations/digital-sign/TokenExpired',
                    '412': 'operations/digital-sign/AlreadyVerified',
                    '0': 'operations/digital-sign/TokenExpired'
                }
            }
        };
    }

    static get defaultComponents() {
        return {
            success: 'VerificationCompleted',
            error: {
                '400': 'TokenExpired',
                '412': 'AlreadyVerified',
                '0': 'TokenExpired'
            }
        };
    }

    static getComponentPath(opId, status) {
        const components = merge(this.defaultComponents, this.operations[opId]);
        if (status === 200) {
            return components.success;
        } else {
            return components.error[status];
        }
    }
}